import axios from "axios";
export const addVehicleAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/vehicles/createVehicle`,
      payload.body
    );
    return response;
  } catch (error) {}
};

export const getAllVehiclesFetchAction = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/vehicles/showVehicles`
  );

  return response;
};

export const updateVehicleAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/vehicles/updateVehicle?vehicleId=${payload.vehicleId}`,
    payload.body
  );

  return response;
};

export const addVehicleCategoryAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/vehicles/addCategory`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const showVehicleCategoryAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/vehicles/showCategory`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};
